import React from "react";
import Layout from "../../components/Layout";
import { BlockLoading } from "react-loadingg";

function AccountPage() {
  return (
    <Layout title="帳戶">
      <BlockLoading />
    </Layout>
  );
}

AccountPage.propTypes = {};

export default AccountPage;
